"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = require("./global");
/** 條件 */
var Condition = /** @class */ (function () {
    function Condition(columnOrItems, operator, value, connective) {
        /** 欄位 */
        this.column = undefined;
        /** 複數條件項目 */
        this.items = [];
        /** 邏輯運算子 */
        this.connective = global_1.LogicalConnective.And;
        /** 運算子 */
        this.operator = global_1.Operator.IsNull;
        /** 值 */
        this.value = undefined;
        if (!columnOrItems)
            return; // none condition
        if (typeof columnOrItems === 'string') { // single condition
            this.column = columnOrItems;
            this.operator = operator;
            this.value = value;
            this.connective = connective || global_1.LogicalConnective.And;
        }
        else if (Array.isArray(columnOrItems)) { // multiple conditions
            this.items = columnOrItems;
        }
    }
    Object.defineProperty(Condition.prototype, "isNone", {
        /** 是否為無條件 */
        get: function () { return this.column === undefined && this.items.length === 0; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Condition.prototype, "isSingle", {
        /** 是否為單一條件 */
        get: function () { return this.column !== undefined; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Condition.prototype, "isMultiple", {
        /** 是否為複數條件 */
        get: function () { return !this.isSingle && this.items.length > 0; },
        enumerable: false,
        configurable: true
    });
    Condition.prototype.and = function (columnOrCondition, operator, value) {
        var _this = this;
        var condition = typeof columnOrCondition === 'string'
            ? new Condition(columnOrCondition, operator, value)
            : columnOrCondition;
        // check self
        if (this.isNone) {
            Object.assign(this, condition); // Be second condition when the self is no condition
            return this;
        }
        // checke anothor condition
        if (!condition.isNone) { // Any condition bitwise and no condition always be self. Skip second condition is no condition
            if (this.isSingle) { // single condition convert to multiple condition
                this.items = [new Condition(this.column, this.operator, this.value, global_1.LogicalConnective.And)];
                this.operator = global_1.Operator.IsNull;
                this.column = this.value = undefined;
            }
            if (condition.isMultiple)
                condition.items[0].connective = global_1.LogicalConnective.And;
            if (condition.isSingle || condition.items.some(function (e) { return e.connective !== global_1.LogicalConnective.And; })) {
                this.items.push(condition);
            }
            else
                condition.items.forEach(function (element) {
                    _this.items.push(element);
                });
        }
        return this;
    };
    Condition.prototype.or = function (columnOrCondition, operator, value) {
        var _this = this;
        var condition = typeof columnOrCondition === 'string'
            ? new Condition(columnOrCondition, operator, value)
            : columnOrCondition;
        // check self
        if (this.isNone) {
            Object.assign(this, condition); // Be second condition when the self is no condition
            return this;
        }
        // checke anothor condition
        if (!condition.isNone) { // Any condition bitwise and no condition always be self. Skip second condition is no condition
            if (this.isSingle) { // single condition convert to multiple condition
                this.items = [new Condition(this.column, this.operator, this.value, global_1.LogicalConnective.Or)];
                this.operator = global_1.Operator.IsNull;
                this.column = this.value = undefined;
            }
            if (condition.isMultiple)
                condition.items[0].connective = global_1.LogicalConnective.Or;
            if (condition.isSingle || condition.items.some(function (e) { return e.connective !== global_1.LogicalConnective.Or; })) {
                this.items.push(condition);
            }
            else
                condition.items.forEach(function (element) {
                    _this.items.push(element);
                });
        }
        return this;
    };
    return Condition;
}());
exports.default = Condition;
